(function () {
  class JackpotBonusIntro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;
      this.visible = false;

      this._pressStartBox = undefined;

      this._baseName = "";
      this._anims = [];
    }

    ///////////////////////////////////////////////
    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    ///////////////////////////////////////////////
    onLayoutComplete() {
      this._baseName = "slotContainer:jackpotIntroPopup:jackpotIntro";
      this._pressStartBox = resourceManager.get(
        this._baseName + ":pressStartColourBox"
      );

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      // for (let i = 0; i < 4; i++) {
      //   let anim = resourceManager.get(
      //     this._baseName + ":frameLightningAnim" + i
      //   );
      //   anim.gotoAndStop(0);
      //   anim.visible = false;

      //   this._anims.push(anim);
      // }
    }

    ///////////////////////////////////////////////
    setup() {
      resourceManager.get(this._baseName).visible = true;
      this.whiteOutImg = resourceManager.get(
        "slotContainer:jackpotIntroPopup:jackpotIntro:whiteOut"
      );

      const leftParticleContainer = resourceManager.get(
        "slotContainer:jackpotIntroPopup:jackpotIntro:GoldBackground:leftParticleContainer"
      );
      const rightParticleContainer = resourceManager.get(
        "slotContainer:jackpotIntroPopup:jackpotIntro:GoldBackground:rightParticleContainer"
      );

      this._leftParticles = particleManager.createEmitter(
        "jackPotIntro_Emitter",
        leftParticleContainer,
        0,
        0,
        true
      );

      this._leftParticles.particleEmitter.emit = true;
      this._leftParticles.visible = true;

      this._rightParticles = particleManager.createEmitter(
        "jackPotIntro_Emitter",
        rightParticleContainer,
        0,
        0,
        true
      );

      this._rightParticles.particleEmitter.emit = true;
      this._rightParticles.visible = true;

      // wait for click - anywhere on screen
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        this.closeDialog.bind(this);
    }

    ///////////////////////////////////////////////
    showIntro(callback) {
      this.setup();
      this._callback = callback;

      this.whiteOutImg = resourceManager.get(
        "slotContainer:jackpotIntroPopup:jackpotIntro:whiteOut"
      );

      gsap.to(this.whiteOutImg, {
        duration: 0.5,
        ease: "linear",
        alpha: 1,
        onStart: () => {
          this.whiteOutImg.visible = true;
          this.whiteOutImg.alpha = 0;
        },
        onComplete: () => {
          this.fadeWhiteOut();
        },
      });
    }

    fadeWhiteOut() {
      gsap.to(this.whiteOutImg, {
        duration: 0.25,
        ease: "linear",
        alpha: 0,
        onStart: () => {},
        onComplete: () => {
          this.whiteOutImg.visible = false;
          this.animateCentreParticleIn();
        },
      });
    }

    animateCentreParticleIn() {
      let particleContainer = resourceManager.get(
        "slotContainer:jackpotIntroPopup:centreParticleContainer"
      );
      this._centreParticles = particleManager.createEmitter(
        "sparks_emitter",
        particleContainer,
        0,
        0,
        true
      );

      this._centreParticles.particleEmitter.emit = true;

      // resourceManager
      //   .get("slotContainer:jackpotBonusFeatureContainer:centreParticleContainer")
      //   .addChild(this._centreParticles);

      gsap.fromTo(
        this._centreParticles,
        { alpha: 0 },
        {
          alpha: 1,
          duration: 0.5,
          onStart: () => {
            this._centreParticles.visible = true;
          },
          onComplete: () => {
            this.animateCentreParticleOut();
          },
        }
      );
    }

    animateCentreParticleOut() {
      gsap.fromTo(
        this._centreParticles,
        { alpha: 1 },
        {
          alpha: 0,
          duration: 0.25,
          onComplete: () => {
            this._centreParticles.visible = false;
            this._centreParticles.particleEmitter.emit = false;
            this._centreParticles = undefined;
          },
        }
      );
    }

    ///////////////////////////////////////////////
    closeDialog() {
      //gameData.musicManager.fadeOutPopUpMusic();
      this._leftParticles.visible = false;
      this._leftParticles.particleEmitter.emit = false;
      this._leftParticles = undefined;

      this._rightParticles.visible = false;
      this._rightParticles.particleEmitter.emit = false;
      this._rightParticles = undefined;
      // turn off click processing
      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart =
        undefined;

      resourceManager.get(this._baseName).visible = false;
      resourceManager.get("fireballLinkIntroDim").visible = false;
      this._callback();
    }
  }

  ///////////////////////////////////////////////
  let fireballIntroCreator = function (json) {
    return new JackpotBonusIntro();
  };

  ///////////////////////////////////////////////
  let fireballIntroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  ///////////////////////////////////////////////
  let fireballIntroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "JackpotBonusIntro",
    fireballIntroCreator,
    fireballIntroInitialiser,
    fireballIntroFilesRequired
  );
})();
